import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    paddingTop: 27,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  },
  line: {
    width: 3,
    backgroundColor: theme.palette.grey[300],
    position: 'relative',
    height: 60
  },
  shortLine: {
    height: 60
  },
  accessButton: {
    boxSizing: 'content-box',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    width: 90,
    aspectRatio: '1 / 1',
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: `20px solid ${theme.palette.background.default}`,
    borderRight: 'none',
    borderLeft: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    },
    [theme.breakpoints.down('xs')]: {
      width: '64px'
    },
    [theme.breakpoints.down('sm')]: {
      width: '72px'
    }
  },
  resetButton: {
    boxSizing: 'content-box',
    backgroundColor: theme.palette.grey[200],
    borderRadius: '50%',
    aspectRatio: '1 / 1',
    border: `15px solid ${theme.palette.background.default}`,
    width: 68,
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    },
    [theme.breakpoints.down('xs')]: {
      width: 95,
      boxSizing: 'border-box'
    },
    [theme.breakpoints.down('sm')]: {
      width: 99,
      boxSizing: 'border-box'
    }
  },
  buttonText: {
    lineHeight: 1,
    fontSize: 14,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fontSize: 50,
      [theme.breakpoints.down('xs')]: {
        fontSize: 45
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 50
      }
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 13
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  buttonTextSmall: {
    fontSize: 14,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    '& svg': {
      fontSize: 35,
      [theme.breakpoints.down('xs')]: {
        fontSize: 31
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 31
      }
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 13,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }
}))

export default useStyles
